<template>
  <section class="hero">
    <div class="header">
      <div class="header__links">
        <a href="tel:+17209328109" class="header__call">
          Call: +1-720-932-8109
        </a>
        <a target="_blank" href="https://www.manhattanstreetcapital.com/offering/30417/invest/amount?invest/?utm_source=srax&utm_medium=display&utm_campaign=geosolar&utm_content=20210713" class="header__cta-btn">
          Learn More
        </a>
      </div>
    </div>
    <div class="hero__content">
      <div class="header__logo --mobile">
        <a href="/">
          <img src="../assets/logo-dark.png">
        </a>
      </div>
      <div class="hero__mobile">
        <h1 class="hero__title-mobile --fade-in-up" data-vertical-ivp-class="--animate">
          INVEST IN THE FUTURE OF AMERICA'S ELECTRIC HOME REVOLUTION
        </h1>
      </div>
      <div class="hero__left-column">
        <a href="/" class="header__logo --desktop">
          <img src="../assets/logo-dark.png">
        </a>
        <h1 class="hero__title --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
          INVEST IN THE FUTURE OF AMERICA'S ELECTRIC HOME REVOLUTION
        </h1>
        <h2 class="hero__subtitle --fade-in-up --delay-2" data-vertical-ivp-class="--animate">
          Don’t miss your chance to invest in the future of carbon free living.
        </h2>
        <p class="hero__description --fade-in-up --delay-3" data-vertical-ivp-class="--animate">
          The future of energy is green, and GeoSolar
          Technologies is the company making that future
          a reality for individual homeowners nationwide.
        </p>
        <CTA class="--fade-in-up --delay-5" data-vertical-ivp-class="--animate"/>
      </div>
      <div class="hero__right-column">
      </div>
    </div>
  </section>
</template>

<script>
import CTA from '../components/cta.vue';

export default {
  name: 'hero',
  components: {
	CTA
  },
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/hero.scss";
</style>
